<template>
  <div class="card shadow-sm" style="height: 100%;">
    <div class="card-header py-1 px-2">
      <fa-icon icon="stethoscope"/> status
    </div>
    <div class="card-body text-center d-flex flex-column justify-content-center">
      <div class="status rounded mb-3 py-3" :class="[ currentLevel === 0 ? 'status-success' : 'status-default' ]">
        <fa-icon icon="check"/> OK
      </div>
      <div class="status rounded mb-3 py-3" :class="[ currentLevel === 1 ? 'status-warning' : 'status-default' ]">
        <fa-icon icon="exclamation"/> WARN
      </div>
      <div class="status rounded py-3" :class="[ currentLevel === 2 ? 'status-danger' : 'status-default' ]">
        <fa-icon icon="wrench"/> ALARM
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'status',
  data () {
    return {
      context: null
    }
  },
  computed: {
    ...mapGetters(['currentLevel'])
  }
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/Status.vue